class AutoMarginTop {
    constructor() {
        this.templatePart = document.querySelector('.wp-block-template-part');
        this.contentAreas = document.querySelectorAll('.entry-content');

        // DOMContentLoaded 이벤트 시 실행될 메서드를 호출합니다.
        this.events();
    }

    // 이벤트를 정의합니다.
    events() {
        document.addEventListener('DOMContentLoaded', () => this.setMarginTop());
    }

    // 마진을 설정하는 메서드
    setMarginTop() {
        if (this.templatePart) {
            const templatePartHeight = this.templatePart.offsetHeight;

            // 각 .entry-content 요소에 padding-top을 설정합니다.
            this.contentAreas.forEach((content) => {
                content.style.paddingTop = `${templatePartHeight}px`;
            });
        }
    }
}

// 클래스를 모듈로 내보냅니다.
export default AutoMarginTop;